import clientService from '../../../apiClient';
import { FILE_URL } from '../../../utils/apiEndpoints';
import { genWorkspaceHeader } from '../../../utils/constants';

export const convertFileToFolder = async ({ id, workspaceId, folderMappings }) => {
  if (!id) return { convertedFileToFolder: false, meta_info: { convertedFileId: id } };
  const file = folderMappings[id];
  const isFile = !('parent_id_id' in file) && 'folder_id' in file;
  if (!file || !isFile) return { convertedFileToFolder: false, meta_info: { convertedFileId: id } };
  if (isFile) {
    const fileId = file?.id;
    const response = await clientService.post(`${FILE_URL}/${fileId}/convert_to_folder`, null, {
      headers: genWorkspaceHeader(workspaceId),
    });
    return {
      ...response?.data,
      children: [],
      convertedFileToFolder: true,
    };
  }
};

export default convertFileToFolder;
